import { Component, TemplateRef, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Globle } from 'src/assets/globle';
import { LocalStorageService } from 'ngx-webstorage';
import { ExcelService } from '../excel.service';
import * as ExcelJS from 'exceljs';
import { CategoryInventory } from './invCategory.model';
import { SubCategoryInventory } from './invSubCategory.model';
import { ProductInventory } from './invProduct.model';
import { ProductcardinvService } from './productcardinv.service';


@Component({
  selector: 'app-productcardsinventory',
  templateUrl: './productcardsinventory.component.html',
  styleUrls: ['./productcardsinventory.component.css']
})
export class ProductcardsinventoryComponent implements OnInit, AfterViewInit {

  cardCode: string = "";
  categoryInventory: CategoryInventory[] = [];
  subCategoryInventory: SubCategoryInventory[] = [];
  productInventory: ProductInventory[] = [];

  displayedColumns: string[] = ["category", "addedCount", "soldCount", "unSoldCount", "prevCountUnsold",
    "details"];
  dataSource!: MatTableDataSource<CategoryInventory>;
  @ViewChild('paginatorCategory') paginatorCategory!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;


  displayedColumnsSubCategory: string[] = ["subCategory", "addedCount", "soldCount", "unSoldCount", "prevCountUnsold",
    "details"];
  dataSourceSubCategory!: MatTableDataSource<SubCategoryInventory>;
  @ViewChild('paginatorSubCategory') paginatorSubCategory!: MatPaginator;
  @ViewChild(MatSort) sortSubCategory!: MatSort;

  displayedColumnsProduct: string[] = ["product", "addedCount", "soldCount", "unSoldCount", "prevCountUnsold"];
  dataSourceProduct!: MatTableDataSource<ProductInventory>;
  @ViewChild('paginatorProduct') paginatorProduct!: MatPaginator;
  @ViewChild(MatSort) sortProduct!: MatSort;

  spinnerOverlay = false;

  viewSubCategoryDetails = false;
  viewProductDetails = false;
  subCategoryName = "";


  public contentRef!: TemplateRef<any>;
  public contentRef1!: TemplateRef<any>;
  public contentRef2!: TemplateRef<any>;
  public contentRef3!: TemplateRef<any>;
  pageSizeCategory: number = 10;
  pageSizeSubCategory: number = 10;
  pageSizeProduct: number = 10;

  @ViewChild('fromDate') fromDate!: ElementRef;
  @ViewChild('toDate') toDate!: ElementRef;

  roleName!: string;

  catgType: { id: number, name: string }[] = [
    { id: -1, name: "all" },
    { id: 1, name: "telecom" },
    { id: 2, name: "others" },
  ];
  selectedType: number = -1;
  fromTime = '00:00';
  toTime = '23:59';

  constructor(private service: ProductcardinvService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private storage: LocalStorageService,
    private excelService: ExcelService,
    private globle: Globle) {

  }

  ngOnInit(): void {
    this.pageSizeCategory = this.globle.pageSize;
    this.pageSizeSubCategory = this.globle.pageSize;
    this.pageSizeProduct = this.globle.pageSize;
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginatorCategory;
    this.dataSource.sort = this.sort;
    this.dataSourceSubCategory.paginator = this.paginatorSubCategory;
    this.dataSourceSubCategory.sort = this.sortSubCategory;
    this.dataSourceProduct.paginator = this.paginatorProduct;
    this.dataSourceProduct.sort = this.sortProduct;
  }

  getCategoryInv() {
    this.spinnerOverlay = true;
    this.service.getInventoryByCategory(this.selectedType, this.getSearchFromDateTime(), this.getSearchToDateTime())
      .subscribe(data => {

        this.categoryInventory = data;

        this.dataSource = new MatTableDataSource(this.categoryInventory);
        this.dataSource.paginator = this.paginatorCategory;
        this.dataSource.sort = this.sort;
        this.spinnerOverlay = false;
      },
        error => {
          console.log(error);
          this.spinnerOverlay = false;
          this.categoryInventory = [];
          this.dataSource = new MatTableDataSource(this.categoryInventory);
          this.dataSource.paginator = this.paginatorCategory;
          this.dataSource.sort = this.sort;
        })
  }

  getSubCategoryInv(categoryId: number) {
    this.spinnerOverlay = true;
    this.service.getInventoryBySubCategory(categoryId, this.getSearchFromDateTime(), this.getSearchToDateTime())
      .subscribe(data => {
        this.viewSubCategoryDetails = true;
        this.subCategoryInventory = data;

        this.dataSourceSubCategory = new MatTableDataSource(this.subCategoryInventory);
        this.dataSourceSubCategory.paginator = this.paginatorSubCategory;
        this.dataSourceSubCategory.sort = this.sortSubCategory;
        this.spinnerOverlay = false;
      },
        error => {
          console.log(error);
          this.spinnerOverlay = false;
          this.subCategoryInventory = [];
          this.dataSourceSubCategory = new MatTableDataSource(this.subCategoryInventory);
          this.dataSourceSubCategory.paginator = this.paginatorSubCategory;
          this.dataSourceSubCategory.sort = this.sortSubCategory;
        })
  }

  getProductInv(subCategoryId: number) {
    this.spinnerOverlay = true;
    this.service.getInventoryByProduct(subCategoryId, this.getSearchFromDateTime(), this.getSearchToDateTime())
      .subscribe(data => {
        console.log(data)
        this.viewSubCategoryDetails = false;
        this.viewProductDetails = true;
        this.productInventory = data;

        this.dataSourceProduct = new MatTableDataSource(this.productInventory);
        this.dataSourceProduct.paginator = this.paginatorProduct;
        this.dataSourceProduct.sort = this.sortProduct;
        this.spinnerOverlay = false;
      },
        error => {
          console.log(error);
          this.spinnerOverlay = false;
          this.productInventory = [];
          this.dataSourceProduct = new MatTableDataSource(this.productInventory);
          this.dataSourceProduct.paginator = this.paginatorProduct;
          this.dataSourceProduct.sort = this.sortProduct;
        })
  }

  details(row: any) {

    this.getSubCategoryInv(row.id);

  }

  detailsSubCategory(row: any) {
    this.subCategoryName = row.subCategory;
    this.getProductInv(row.id);
  }

  search() {
    this.getCategoryInv();
  }

  back() {
    if (this.viewProductDetails) {
      this.viewProductDetails = false;
      this.viewSubCategoryDetails = true;
    }
    else {
      this.viewSubCategoryDetails = false;
    }
  }

  openSnackBar(message: string, cssclass: string) {
    this.snackBar.open(message, 'Close', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(this.contentRef, {
      width: '300px',
    });
  }

  openDialogView(): void {
    const dialogRef = this.dialog.open(this.contentRef1, {
      width: '500px',
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }


  clearTable() {
    this.categoryInventory = [];
    this.dataSource = new MatTableDataSource(this.categoryInventory);
    this.dataSource.paginator = this.paginatorCategory;
    this.dataSource.sort = this.sort;
  }

  onDateSearch() {
    this.getCategoryInv();
  }

  private getSearchFromDateTime(): string {
    const date = this.fromDate?.nativeElement?.value;
    if (!date) {
      return '';
    }
    return `${date} ${this.fromTime || '00:00'}`;
  }

  private getSearchToDateTime(): string {
    const date = this.toDate?.nativeElement?.value;
    if (!date) {
      return '';
    }
    const time = this.toTime || '23:59';
    return `${date} ${time.length === 5 ? time + ':59' : time}`;
  }



  getTotalAddCountCategory() {
    return this.categoryInventory.map(t => t.addedCount).reduce((acc, value) => acc + value, 0);
  }

  getTotalCostAddCountCategory() {
    return this.categoryInventory.map(t => t.addedCount_costPrice).reduce((acc, value) => acc + value, 0).toFixed(3);
  }

  getTotalSoldCountCategory() {
    return this.categoryInventory.map(t => t.soldCount).reduce((acc, value) => acc + value, 0);
  }

  getTotalSoldCountCostCategory() {
    return this.categoryInventory.map(t => t.soldCount_costPrice).reduce((acc, value) => acc + value, 0).toFixed(3);
  }

  getTotalUnsoldCountCategory() {
    return this.categoryInventory.map(t => t.unSoldCount).reduce((acc, value) => acc + value, 0);
  }

  getTotalUnSoldCostCategory() {
    return this.categoryInventory.map(t => t.unSoldCount_costPrice).reduce((acc, value) => acc + value, 0).toFixed(3);
  }

  getTotalPrevUnsoldCountCategory() {
    return this.categoryInventory.map(t => t.prevCountUnsold).reduce((acc, value) => acc + value, 0);
  }

  getTotalPrevUnsoldCostCategory() {
    return this.categoryInventory.map(t => t.prevCountUnsold_costPrice).reduce((acc, value) => acc + value, 0).toFixed(3);
  }







  getTotalAddCountSubCategory() {
    return this.subCategoryInventory.map(t => t.addedCount).reduce((acc, value) => acc + value, 0);
  }

  getTotalCostAddCountSubCategory() {
    return this.subCategoryInventory.map(t => t.addedCount_costPrice).reduce((acc, value) => acc + value, 0).toFixed(3);
  }

  getTotalSoldCountSubCategory() {
    return this.subCategoryInventory.map(t => t.soldCount).reduce((acc, value) => acc + value, 0);
  }

  getTotalSoldCountCostSubCategory() {
    return this.subCategoryInventory.map(t => t.soldCount_costPrice).reduce((acc, value) => acc + value, 0).toFixed(3);
  }

  getTotalUnsoldCountSubCategory() {
    return this.subCategoryInventory.map(t => t.unSoldCount).reduce((acc, value) => acc + value, 0);
  }

  getTotalUnSoldCostSubCategory() {
    return this.subCategoryInventory.map(t => t.unSoldCount_costPrice).reduce((acc, value) => acc + value, 0).toFixed(3);
  }

  getTotalPrevUnsoldCountSubCategory() {
    return this.subCategoryInventory.map(t => t.prevCountUnsold).reduce((acc, value) => acc + value, 0);
  }

  getTotalPrevUnsoldCostSubCategory() {
    return this.subCategoryInventory.map(t => t.prevCountUnsold_costPrice).reduce((acc, value) => acc + value, 0).toFixed(3);
  }






  getTotalAddCountProduct() {
    return this.productInventory.map(t => t.addedCount).reduce((acc, value) => acc + value, 0);
  }

  getTotalCostAddCountProduct() {
    return this.productInventory.map(t => t.addedCount_costPrice).reduce((acc, value) => acc + value, 0).toFixed(3);
  }

  getTotalSoldCountProduct() {
    return this.productInventory.map(t => t.soldCount).reduce((acc, value) => acc + value, 0);
  }

  getTotalSoldCountCostProduct() {
    return this.productInventory.map(t => t.soldCount_costPrice).reduce((acc, value) => acc + value, 0).toFixed(3);
  }

  getTotalUnsoldCountProduct() {
    return this.productInventory.map(t => t.unSoldCount).reduce((acc, value) => acc + value, 0);
  }

  getTotalUnSoldCostProduct() {
    return this.productInventory.map(t => t.unSoldCount_costPrice).reduce((acc, value) => acc + value, 0).toFixed(3);
  }

  getTotalPrevUnsoldCountProduct() {
    return this.productInventory.map(t => t.prevCountUnsold).reduce((acc, value) => acc + value, 0);
  }

  getTotalPrevUnsoldCostProduct() {
    return this.productInventory.map(t => t.prevCountUnsold_costPrice).reduce((acc, value) => acc + value, 0).toFixed(3);
  }



  exportAsXLSX(): void {
    var exportList = [];
    var totals = {
      "A": "Totals", // Label for the totals row
      "B": 0,
      "C": 0,
      "D": 0,
      "E": 0,
      "F": 0,
      "G": 0,
      "H": 0,
      "I": 0
    };

    var list: any[] = []
    list = this.viewProductDetails ? this.productInventory :
      this.viewSubCategoryDetails ? this.subCategoryInventory : this.categoryInventory;

    for (let i = 0; i < list.length; i++) {

      var obj = {
        "A": this.viewProductDetails ? list[i]["product"] : this.viewSubCategoryDetails ?
          list[i]["subCategory"] : list[i]["category"],
        "B": list[i].addedCount,
        "C": list[i].addedCount_costPrice,
        "D": list[i].soldCount,
        "E": list[i].soldCount_costPrice,
        "F": list[i].unSoldCount,
        "G": list[i].unSoldCount_costPrice,
        "H": list[i].prevCountUnsold,
        "I": list[i].prevCountUnsold_costPrice
      }

      exportList.push(obj);

      totals.B += list[i].addedCount;
      totals.C += list[i].addedCount_costPrice;
      totals.D += list[i].soldCount;
      totals.E += list[i].soldCount_costPrice;
      totals.F += list[i].unSoldCount;
      totals.G += list[i].unSoldCount_costPrice;
      totals.H += list[i].prevCountUnsold;
      totals.I += list[i].prevCountUnsold_costPrice;
    }
    exportList.push(totals);

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Product totals');

    worksheet.columns = [
      { header: 'الفئة الرئيسية', key: 'A', width: 30, },
      { header: 'العدد المدخل', key: 'B', width: 15 },
      { header: 'كلفة العدد المدخل', key: 'C', width: 25 },
      { header: 'العدد المباع', key: 'D', width: 15 },
      { header: 'كلفة العدد المباع', key: 'E', width: 25 },
      { header: 'العدد الغير مباع', key: 'F', width: 15 },
      { header: 'كلفة العدد الغير مباع', key: 'G', width: 25 },
      { header: 'العدد السابق المتبقي', key: 'H', width: 25 },
      { header: 'كلفة العدد السابق المتبقي', key: 'I', width: 25 }
    ];

    exportList.forEach(item => {
      worksheet.addRow(item);
    });

    const headerRow = worksheet.getRow(1);
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '4F81BD' } // Blue background color
      };
      cell.font = {
        bold: true,
        color: { argb: 'FFFFFF' } // White font color
      };
      cell.alignment = { vertical: 'middle', horizontal: 'center' }; // Center alignment
    });

    const lastRow = worksheet.lastRow;
    lastRow!.eachCell((cell) => {

      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFF00' } // Yellow background color
      };
      cell.font = {
        bold: true,
        color: { argb: 'red' },
      };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };

    });



    // const dateTimeRow = worksheet.addRow([]); // Add an empty row after the table
    // const dateTimeCell = dateTimeRow.getCell(1); // Use the first column
    // dateTimeCell.value = `Report generated on: ${new Date().toLocaleString()}`; // Insert current date and time
    // dateTimeCell.font = {
    //   bold: true,
    //   color: { argb: '000000' } // Black font color
    // };
    // dateTimeCell.alignment = { horizontal: 'left' };

    let fromDate = this.getSearchFromDateTime();
    let toDate = this.getSearchToDateTime();

    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = (this.viewProductDetails ? 'Product_inventory_totals-' :
        this.viewSubCategoryDetails ? 'subCategory_inventory_totals-' :
          'category_inventory_totals-') + fromDate + '-' + toDate + '.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
    });

    // this.excelService.exportAsExcelFile(exportList, 'تقرير مخزون فترة');
  }


}
